/* HILO — desktop arrows for the category circle row.

   Wraps .hilo-explore__cats and adds a prev / next pair ABOVE it, aligned
   right. Kept out of sections/hilo-explore.liquid deliberately: that file
   renders every collection page and is 38 KB, so a small enhancement from
   outside is far less risky than editing it.

   The row is not re-rendered when filters change — the Explore script only
   replaces the grid, chips and facets — so wrapping it once at load is safe.
*/
(function () {
  if (window.__hiloCatArrows) return;
  window.__hiloCatArrows = true;

  var SVG_PREV = '<svg viewBox="0 0 8 12" fill="none" aria-hidden="true" focusable="false"><path d="M7 1 2 6l5 5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_NEXT = '<svg viewBox="0 0 8 12" fill="none" aria-hidden="true" focusable="false"><path d="M1 1l5 5-5 5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function button(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'hilo-catnav__btn hilo-catnav__btn--' + dir;
    b.innerHTML = dir === 'prev' ? SVG_PREV : SVG_NEXT;
    b.setAttribute('aria-label', dir === 'prev' ? 'Previous categories' : 'Next categories');
    return b;
  }

  function setup(row) {
    if (!row || row.dataset.hiloCatnav) return;
    row.dataset.hiloCatnav = '1';

    /* wrapper > [ controls, track > row ] */
    var wrap = document.createElement('div');
    wrap.className = 'hilo-catnav';
    row.parentNode.insertBefore(wrap, row);

    var ctrls = document.createElement('div');
    ctrls.className = 'hilo-catnav__ctrls';

    var track = document.createElement('div');
    track.className = 'hilo-catnav__track';

    wrap.appendChild(ctrls);
    wrap.appendChild(track);
    track.appendChild(row);

    var prev = button('prev');
    var next = button('next');
    ctrls.appendChild(prev);
    ctrls.appendChild(next);

    function maxScroll() { return row.scrollWidth - row.clientWidth; }

    function update() {
      var max = maxScroll();
      /* A little slack: sub-pixel widths mean scrollLeft rarely lands exactly
         on the maximum. */
      var scrollable = max > 4;
      wrap.classList.toggle('is-scrollable', scrollable);

      var atStart = row.scrollLeft <= 2;
      var atEnd   = row.scrollLeft >= max - 2;

      prev.disabled = atStart;
      next.disabled = atEnd;
      wrap.classList.toggle('can-prev', scrollable && !atStart);
      wrap.classList.toggle('can-next', scrollable && !atEnd);
    }

    function step(dir) {
      /* Move by most of a screenful, leaving one circle visible as an anchor
         so the eye does not lose its place. */
      var amount = Math.max(160, row.clientWidth * 0.8);
      row.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); step(1); });

    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    /* Images load late and change the row width, so re-measure once they land. */
    var imgs = row.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) imgs[i].addEventListener('load', update, { once: true });
    }

    update();
    /* Fonts settling shifts label widths, which shifts the total width. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
  }

  function scan() {
    var rows = document.querySelectorAll('.hilo-explore__cats');
    for (var i = 0; i < rows.length; i++) setup(rows[i]);
  }

  scan();

  /* The theme editor re-renders sections on edit, so catch a fresh row. */
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.classList && n.classList.contains('hilo-explore__cats')) setup(n);
        else if (n.querySelector) scan();
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();